import { Card, CardProps } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

type BlogCardWebWrapperProps = CardProps;

export const BlogCardWebWrapper = ({
  className,
  children,
  ...props
}: BlogCardWebWrapperProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <Card
      sx={{
        borderBottom: "2px solid",
        width: "100%",
        borderBottomColor: colors.surface.surfContainerHigh,
        paddingBottom: "1.5rem",
        backgroundColor: "transparent",
        backgroundImage: "none",
        display: "flex",
        alignItems: "center",
        "@media (min-width: 1440px)": {
          height: "18rem",
        },
      }}
      className={className}
      {...props}
    >
      {children}
    </Card>
  );
};
